export type CheckOutMarker = {
  date?: string;
  source?: "auto" | "email";
  /** The visitor typed the time in; it was not measured. */
  reported?: boolean;
  /** When the automatic check-out was, before the visitor corrected it. */
  autoDate?: string;
};

export type CheckOutMethod = "reported" | "email" | "auto";

/** How a check-out came about; null at the reception, in the CMS or by Synguard. */
export const checkOutMethod = (
  marker?: CheckOutMarker | null,
): CheckOutMethod | null => {
  if (marker?.reported) {
    return "reported";
  }

  // Only the sources this CMS knows, so an unknown one never shows a raw i18n key.
  return marker?.source === "auto" || marker?.source === "email"
    ? marker.source
    : null;
};

export default checkOutMethod;
